import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IMedicalRecord } from '../types/interfaces/IMedicalRecord';
import { IMedicalRecordFiltersDTO } from '../types/interfaces/IMedicalRecordFilters';

export async function getMedicalRecords(
  filters?: IMedicalRecordFiltersDTO
): Promise<ApiResponse<IMedicalRecord[]>> {
  const params: Record<string, any> = {};
  if (filters) {
    if (filters.userId) params.userId = filters.userId;
    if (filters.institutionId) params.institutionId = filters.institutionId;
    if (filters.specialtyId) params.specialtyId = filters.specialtyId;
    if (filters.searchQuery) params.searchQuery = filters.searchQuery;
    if (filters.type && filters.type !== 'all') params.type = filters.type;
    if (filters.status && filters.status !== 'all') params.status = filters.status;
    if (filters.page !== undefined) params.page = filters.page;
    if (filters.pageSize !== undefined) params.pageSize = filters.pageSize;
  }
  return apiClient.get<IMedicalRecord[]>('/medical-records', params);
}

export async function getMedicalRecordById(
  id: string
): Promise<ApiResponse<IMedicalRecord>> {
  return apiClient.get<IMedicalRecord>(`/medical-records/${id}`);
}

export async function createMedicalRecord(
  data: Omit<IMedicalRecord, 'id'>
): Promise<ApiResponse<IMedicalRecord>> {
  return apiClient.post<IMedicalRecord>('/medical-records', data);
}

export async function updateMedicalRecord(
  id: string,
  data: Partial<IMedicalRecord>
): Promise<ApiResponse<IMedicalRecord>> {
  return apiClient.put<IMedicalRecord>(`/medical-records/${id}`, data);
}

export async function deleteMedicalRecord(id: string): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`/medical-records/${id}`);
}
